var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOpen)?_c('AgencyDetailsDialog',{attrs:{"is-open":_vm.isOpen,"title":"New Agency","actionName":"Create Agency","loading":_vm.isLoading},on:{"close":_vm.closeNewAgencyDialog,"submit":_vm.onSubmit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }